<template>
  <b-container>
    <Form
      :media="media"
      @loadImage="loadImage"
      @onSubmit="onSubmit"
    />
  </b-container>
</template>

<script>
import { COMMUNITY_CREATE } from "@/store/constant";
import Form from "@/components/Community/Form";

export default {
  name: 'CommunityCreate',
  components: { Form },
  data() {
    return {
      media: null,
    }
  },
  methods: {
    onSubmit(data, canvas) {
      let formData = new FormData();
      data['token'] = localStorage.getItem('user-token');
      formData.append("data", JSON.stringify(data));

      if (!canvas) {
        alert('画像を選択してください');
        return;
      }
      canvas.toBlob(blob => {
        formData.append('files.media', blob);
        this.$store.dispatch(COMMUNITY_CREATE, formData)
          .then(() => {
            this.$router.push({ name: 'communities' });
          })
      });
    },
    loadImage(event) {
      const input = event.target;
      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.media = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
  }
}
</script>
